import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import {ModalController} from '@ionic/angular';
import { ActivatedRoute } from '@angular/router';
import { RequestService } from 'src/app/services/request/request.service';
import { AppNavigationStateService } from 'src/app/services/startup/app-navigation-state.service';
import { Router } from '@angular/router';
import { Clipboard } from '@capacitor/clipboard';
import { Browser } from '@capacitor/browser';
import Swal2 from 'sweetalert2';
import * as QRCode from 'qrcode';
import { COINPAYMENTS_V2_CURRENCY_IMAGES } from 'src/app/components/go-ecosystem/wallet-app/coinpayments-currencies';

@Component({

  selector: 'app-inline-bowsing',
  templateUrl: './inline-bowsing.component.html',
  styleUrls: ['./inline-bowsing.component.scss'],
})
export class InlineBowsingComponent implements OnInit, OnDestroy {
  listing;
   publication = '';  // <-- keep as string
  unsanitezed_url;
  @Input()coinpaymentsCheckOut;
  @Input()qrcode_url;
  @Input()payment_uri;
  @Input()subtotal;
  @Input()buyer_fee;
  @Input()amount;
  @Input()address;
  @Input()timeout = 540;
  @Input()destination_tag;
  @Input()confirms_needed;
  @Input()txn_id;
  @Input()currency;
    @Input()bbva;
  addressQrCodeUrl = '';
  paymentQrCodeUrl = '';
  selectedPaymentView: 'amount' | 'address' = 'amount';
  objmedia; //earth guesty
  private interval: any;
lkfilm;
  @Input() url: any;
  @Input() externalBrowserFallback = false;
  private iframeLoadTimeout?: ReturnType<typeof setTimeout>;
  private externalBrowserOpened = false;
  constructor(
    private sanitizer: DomSanitizer,
    private ModalController: ModalController,
      private route: ActivatedRoute,
     private request: RequestService,
      private router: Router,
      private navigationState: AppNavigationStateService,
  ) { }
toLocal(d?: string) { return d ? new Date(d).toLocaleDateString() : '—'; }

  ngOnInit() {
    this.route.queryParamMap.subscribe(params => {
    const flag = params.get('lkfilm');
    const isMobileMode = flag === 'true';

  

            		if (isMobileMode) {
      this.lkfilm=true;
		}else{
   
		}
      });
        const initial = this.route.snapshot.queryParamMap.get('url');
this.route.queryParamMap.subscribe(params => {
  if(params.get('url')){
   this.url = params.get('url') ?? initial ?? '';
  }
   
      if(this.bbva){
         this.url ='https://portal.bbva.mx/aplicativos/buscador-sucursales/index.jsp';
      }
        console.log('this.url', this.url)
 this.publication = params.get('publication') || '';
 console.log(' this.publication', this.publication)
     const raw = params.get('objmedia');
    if (raw) {
      try { this.objmedia = JSON.parse(raw); 
        console.log('this.objmedia',this.objmedia)
        this.fetch_listing();
      }
      catch {
        try { this.objmedia = JSON.parse(decodeURIComponent(raw)); } catch {}
      }
    }

    });
    if(this.coinpaymentsCheckOut){
      this.timeout = Number(this.timeout) > 0 ? Number(this.timeout) : 540;
      this.generatePaymentQrCode();
      this.generateAddressQrCode();


      // Update the countdown every second
      this.interval = setInterval(() => {
        if (this.timeout > 0) {
          this.timeout--;
     
        } else {
          clearInterval(this.interval); // Stop the interval when timeout reaches zero
        }
      }, 1000);
    }else if(this.url){
      this.unsanitezed_url=this.url;
      this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
      console.log('this.url', this.url)
      this.startIframeLoadGuard();
    }
  
  }
  fetch_listing(){
    this.request.createRequestPost('make_a_guesty_request', {listing_id:this.objmedia.ListingId})
		.then((data) => {
		 //console.log(data, 'make_a_guesty_request fetched', data);
		if (typeof data === 'string') {
       let parsedData;
                try {
                    // Attempt to parse the JSON string into an object
                    parsedData = JSON.parse(data);
                  this.listing=parsedData;
                } catch (e) {
                    console.error('Error: Failed to parse JSON response.', e);
                    // Log the problematic string to help with debugging
                    console.error('Raw response string:', data);
                    // Stop further execution if parsing fails
                    return;
                }


            }else{
           
  this.listing=data;
     console.log('this.listing',this.listing)

            }
		 


		}).catch((error) => {
		  console.error('Failed to send notification:', error);
	   
		});
  }

  ngOnDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.clearIframeLoadGuard();
  }

  onIframeLoad(): void {
    this.clearIframeLoadGuard();
  }

  async onIframeError(): Promise<void> {
    await this.openExternalBrowserFallback('iframe-error');
  }

  private startIframeLoadGuard(): void {
    if (!this.externalBrowserFallback || !this.unsanitezed_url) return;
    this.clearIframeLoadGuard();
    this.iframeLoadTimeout = setTimeout(() => {
      void this.openExternalBrowserFallback('iframe-timeout');
    }, 8000);
  }

  private clearIframeLoadGuard(): void {
    if (this.iframeLoadTimeout) {
      clearTimeout(this.iframeLoadTimeout);
      this.iframeLoadTimeout = undefined;
    }
  }

  private async openExternalBrowserFallback(reason: string): Promise<void> {
    if (
      !this.externalBrowserFallback ||
      this.externalBrowserOpened ||
      !this.unsanitezed_url
    ) {
      return;
    }

    this.externalBrowserOpened = true;
    this.clearIframeLoadGuard();
    console.warn(`[InlineBrowsing] Opening external browser after ${reason}.`);

    try {
      await Browser.open({ url: String(this.unsanitezed_url) });
      await this.ModalController.dismiss({ openedExternally: true, reason });
    } catch (error) {
      this.externalBrowserOpened = false;
      console.error('[InlineBrowsing] External browser fallback failed:', error);
    }
  }
  fallbackUrl = 'https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/c8/18/0a/c8180a32-8f40-aca0-9556-9b7aeee6f190/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/1200x630wa.png';

getListingImage(l: any): string {
  return l?.picture?.large
      || l?.picture?.regular
      || l?.picture?.thumbnail
      || (l?.pictures && l.pictures[0] && (l.pictures[0].original || l.pictures[0].large || l.pictures[0].regular))
      || this.fallbackUrl;
}
  async dismiss(): Promise<void> {
    const modal = await this.ModalController.getTop();
    if (modal) {
      await modal.dismiss();
      return;
    }

    const fallback = this.navigationState.backFallbackForCurrentRoute(this.router.url);
    const didNavigate = await this.router.navigateByUrl(fallback, { replaceUrl: true });
    if (!didNavigate) {
      await this.router.navigateByUrl('/home/ecosystem-page', { replaceUrl: true });
    }
    this.lkfilm=false;
  }

  async copyCoinpaymentAddress() {
    await this.copyToClipboard(this.address, 'Dirección copiada');
  }

  async copyCoinpaymentDestinationTag() {
    await this.copyToClipboard(this.destination_tag, 'Destination tag copiado');
  }

  getCurrencyLogo(): string {
    const symbol = String(this.currency || '').toUpperCase();
    return COINPAYMENTS_V2_CURRENCY_IMAGES[symbol]
      || COINPAYMENTS_V2_CURRENCY_IMAGES[symbol.split('.')[0]]
      || '';
  }

  getCurrencyLabel(): string {
    return String(this.currency || 'Crypto').split('.')[0].toUpperCase();
  }

  formatPaymentValue(value: any): string {
    if (value === null || value === undefined || value === '') return '—';
    return String(value);
  }

  private generateAddressQrCode() {
    const address = this.address?.toString?.() || '';
    if (!address) {
      this.addressQrCodeUrl = '';
      return;
    }

    QRCode.toDataURL(address, { margin: 1, width: 220 }, (error, url) => {
      if (error) {
        console.error('[InlineBrowsing] Could not generate address QR:', error);
        this.addressQrCodeUrl = '';
        return;
      }

      this.addressQrCodeUrl = url;
    });
  }

  private generatePaymentQrCode() {
    if (this.qrcode_url) {
      this.paymentQrCodeUrl = this.qrcode_url;
      return;
    }

    const address = this.address?.toString?.() || '';
    const amount = this.amount?.toString?.() || '';
    if (!address) {
      this.paymentQrCodeUrl = '';
      return;
    }

    const suppliedPaymentUri = typeof this.payment_uri === 'string' ? this.payment_uri : '';
    const payload = suppliedPaymentUri || this.buildPaymentUri(address, amount, this.currency);
    QRCode.toDataURL(payload, { margin: 1, width: 320 }, (error, url) => {
      if (error) {
        console.error('[InlineBrowsing] Could not generate payment QR:', error);
        this.paymentQrCodeUrl = '';
        return;
      }

      this.paymentQrCodeUrl = url;
    });
  }

  private buildPaymentUri(address: string, amount: string, currency: string): string {
    const symbol = String(currency || '').toUpperCase().split('.')[0];
    const schemes: { [key: string]: string } = {
      BTC: 'bitcoin',
      BCH: 'bitcoincash',
      LTC: 'litecoin',
      DOGE: 'dogecoin',
      DASH: 'dash',
    };
    const scheme = schemes[symbol];

    if (scheme && amount) {
      return `${scheme}:${encodeURIComponent(address)}?amount=${encodeURIComponent(amount)}`;
    }

    return address;
  }

  async copyToClipboard(value: any, successTitle: string) {
    const text = value?.toString?.() || '';
    if (!text) {
      return;
    }

    try {
      await Clipboard.write({ string: text });
    } catch (error) {
      await navigator.clipboard?.writeText(text);
    }

    Swal2.fire({
      title: successTitle,
      icon: 'success',
      timer: 1400,
      showConfirmButton: false,
      toast: true,
      position: 'top-end',
      color: '#ffffff',
      background: '#010f4e',
      timerProgressBar: true
    });
  }

  getSubdomain(): string {
    if(!this.url){
      return;
    }
    let url= this.unsanitezed_url.toString();
    if (url && typeof url === 'string') {
      // Remove the protocol (http:// or https://) if present
      let urlWithoutProtocol = url.replace(/^https?:\/\//, '');

      // Split the URL by dots
      let parts = urlWithoutProtocol.split('.');

      // If the URL starts with 'www', return the second part (subdomain)
      if (parts.length > 1 && parts[0] === 'www') {
        return parts[1];  // Returns 'documents'
      }
      
      // If there's no 'www', return the first part before the first dot
      return parts[0];  // Returns 'documents' even if 'www' is not present
    }

    return '';
  }
  navigate(){
    window.open(this.unsanitezed_url, '_blank'); // Open the URL in a new tab or window
  }
}
